import axios from "axios";
// axios.defaults.withCredentials = true;

export const trackEmployeeApi = async(fieldEmpId, setGeolocation, setHalt, status) =>{
    if(status === "ALLOWED"){
        try {
            const sendRequest = await axios.post(`${process.env.REACT_APP_API_URL}/track/findTravelHistory`, { fieldEmpId: fieldEmpId });
            // console.log("Track Employee Api: ",sendRequest.data);
            if(sendRequest.data.data === null){
                // console.log('This has run');
                setGeolocation([]);
                alert('No to Data to show');
                return false;
            }
            setGeolocation(sendRequest.data?.data?.gioLocList);
            setHalt(sendRequest.data?.data?.halt);
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    } else{
        alert('Emploee has not allowed tracking');
    }
}